import { CmsApplianceDetailsPage } from '../../models/appliance-details-page/cms/cms-appliance-details-page.interface';
import { mockCmsApplianceDetailsForm } from './cms-appliance-details-form.mock';
import { mockCmsArticleSearchForm } from './cms-article-search-form.mock';
import { mockCmsSelfFixRoot } from './cms-self-fix-root.mock';

export const mockCmsApplianceDetailsPage: CmsApplianceDetailsPage = {
  ...mockCmsSelfFixRoot,
  ...mockCmsApplianceDetailsForm,
  ...mockCmsArticleSearchForm,
};
